import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import currencyFormatter from 'currency-formatter';
import Button from 'yoda-core-components/lib/components/Button';
import classNames from 'classnames/bind';
import {
    CURRENCY_US,
    ANALYTICS_ACTIONS_FIND_COUPON,
} from 'yoda-checkout-components/lib/common/Constants';
import * as checkoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as slidePanelActions from 'yoda-checkout-components/lib/actions/SlidePanelAction';
import * as coCouponActions from 'yoda-checkout-components/lib/actions/COCouponAction';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from '../SpecialOffers/SpecialOffers.css';

const cx = classNames.bind(styles);

export class CouponApplied extends Component {
    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        orderAdjustments: PropTypes.objectOf(PropTypes.object),
        display: PropTypes.bool,
        applyCouponAnimations: PropTypes.objectOf(PropTypes.object),
    };

    static defaultProps = {
        orderAdjustments: {},
        display: false,
        applyCouponAnimations: {},
    };

    getContainerAndMessageClasses = () => {
        const {
            display,
            applyCouponAnimations: { animation },
        } = this.props;

        let messageClasses = dt([
            'border-dashed',
            'border-2',
            'border-gray-15',
            'rounded-medium',
            'p-4',
        ]);
        let containerClasses = `${dt(['text-center'])} ${cx('couponAppliedContainer')}`;
        messageClasses = `${cx('animate', messageClasses, 'fadeOut', 'couponAppliedElement')}
            ${dt([
                'overflow-hidden',
                'md:inline-block',
                'lg:block',
                'opacity-0',
                'max-h-0',
                'mdOnly:max-w-[352px]',
                'mx-auto',
                'my-0',
                'rounded-lg',
            ])}`;
        containerClasses = `${cx('animate', containerClasses, 'fadeOut')} ${dt([
            'overflow-hidden',
            'opacity-0',
            'max-h-0',
        ])}`;

        if (display && animation) {
            containerClasses = `${cx('animate', containerClasses, 'fadeOut')}
                ${dt(['overflow-hidden', 'mb-2', 'lg:mb-4', 'opacity-0', 'max-h-0'])}`;
            messageClasses = `${cx('animate', messageClasses, 'fadeOut')}
                    ${dt([
                        'overflow-hidden',
                        'md:mx-0',
                        'opacity-0',
                        'max-h-0',
                        'lg:mx-0',
                        'lg:mt-4',
                    ])}`;
        } else if (display) {
            containerClasses = `${cx('animate', containerClasses, 'fadeIn')}
                ${dt(['overflow-hidden', '!opacity-100', 'max-h-52', 'mb-2', 'mb-2', 'lg:mb-4'])}`;
            messageClasses = `${cx('animate', messageClasses, 'fadeIn')}
                ${dt([
                    'overflow-hidden',
                    '!opacity-100',
                    'max-h-52',
                    'md:mx-0',
                    'lg:mx-0',
                    'lg:mt-4',
                ])}`;
        }

        return { containerClasses, messageClasses };
    };

    openCouponPanel = (e) => {
        e && e.preventDefault();
        // Open the coupons slideover
        this.props.actions.showCouponsPanel(true);
        // Making this call every time the panel is open to refresh the coupon discounts data.
        // The discounts will be different if the items in the bag has changed.
        this.props.actions.getCOCouponsAction(true);
        // Trigger 'findCoupon' event for DA
        this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_FIND_COUPON);
    };

    render() {
        const {
            orderAdjustments: { amount, value, message },
        } = this.props;

        const { messageClasses, containerClasses } = this.getContainerAndMessageClasses();

        return (
            <div data-automation-id="at-fpac-container" className={containerClasses}>
                <div className={messageClasses}>
                    <div
                        className={dt([
                            'font-open-sans-semibold',
                            'text-small',
                            'text-brand-red',
                            message && 'mb-1',
                        ])}
                    >
                        You saved&nbsp;
                        <span>
                            {currencyFormatter.format(amount, {
                                code: CURRENCY_US,
                                precision: 2,
                            })}
                        </span>
                        &nbsp;with {value}
                    </div>
                    {message && (
                        <div className={dt(['mx-2', 'my-1', 'text-xsmall', 'text-gray-60'])}>
                            {message}
                        </div>
                    )}
                    <Button
                        automationId="view-all-coupons-on-cart"
                        buttonId="view-all-coupons-on-cart"
                        buttonType="Link"
                        size="Sm"
                        onClick={this.openCouponPanel}
                    >
                        View All Coupons
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { applyCouponAnimations } = state;
    return {
        applyCouponAnimations,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...slidePanelActions,
            ...coCouponActions,
            ...checkoutAnalyticsAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CouponApplied);
